var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import _ from 'underscore';
export var checkAuthSlice = {
    checkAuthRequest: function (state) {
        return __assign(__assign({}, state), { pending: true });
    },
    checkAuthSuccess: function (state, action) {
        if (!_.isEqual(state.userInfo, action.payload.userInfo)) {
            return __assign(__assign({}, state), { pending: false, userInfo: action.payload.userInfo, error: null, isAuthenticated: true, menus: action.payload.menus, background: action.payload.background });
        }
        return __assign(__assign({}, state), { pending: false, error: null, isAuthenticated: true, background: action.payload.background });
    },
    checkAuthFailed: function (state, action) { return (__assign(__assign({}, state), { pending: false, userInfo: undefined, error: action.payload.error, isAuthenticated: false, menus: undefined, background: undefined })); },
};
